import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=517dad2c&scoped=true&"
import script from "./Authorized.vue?vue&type=script&lang=ts&"
export * from "./Authorized.vue?vue&type=script&lang=ts&"
import style0 from "./Authorized.vue?vue&type=style&index=0&id=517dad2c&scoped=true&lang=scss&"
import style1 from "./Authorized.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517dad2c",
  null
  
)

export default component.exports